<h1 mat-mdc-dialog-title>{{ 'turbo.dialog.impersonate.title' |translate: 'Impersonate user' }}</h1>
  <div class="dialog-content" style="height: 400px">
    <form [formGroup]="theForm" novalidate [@formState]="state" autocomplete="off">
      <mat-form-field style="width: 100%;">
        <mat-icon matPrefix>supervisor_account</mat-icon>
        <input matInput placeholder="{{ 'turbo.dialog.impersonate.searchBox' |translate:'Search for user'}}" [disabled]="isWorking" formControlName="searchText" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" (input)="updateFilter()" (keydown)="handleKeydown($event)" />
      </mat-form-field>

      <mat-list style="height: 293px; overflow: auto; display: block;">
        <mat-list-item #locationItem [ngClass]="{'active': selectedLocation == location}" (click)="selectLocation(location)" *ngFor="let location of filteredLocations">{{ location.LocationCode }} - {{ location.Name }}, {{ location.Address }}</mat-list-item>
      </mat-list>
    </form>
    <div class="confirmationMessage fullscreenMessage" [@successState]="state">
      <mat-icon>assignment_turned_in</mat-icon>
      {{ 'turbo.dialog.impersonate.msgSuccess' |translate:'Now impersonating '}} {{selectedLocation?.Name}}...
    </div>
  </div>
  <div mat-dialog-actions style="height: 36px; text-align: center; margin-top: 10px">
    <button mat-raised-button color="primary" style="width: 100%;" [disabled]="selectedLocation == undefined" (click)="impersonate()" *ngIf="!isWorking">{{ 'turbo.dialog.impersonate.cmdConfirm' |translate:'Ok'}}</button>
  </div>
  <div class="loader" *ngIf="isWorking">
    <mat-progress-bar mode="indeterminate" style="width: 100%; bottom: 0;" *ngIf="isWorking"></mat-progress-bar>
  </div>
